import React from "react";
import PhoneFrameVideo from "../../../pages/Marketing/components/PhoneFrameVideo";
import { MARKETING_MEDIA } from "../../../config/marketing/media";
import { assets } from "../../../assets/assets";

export default function PatientDoctorMedia() {
    return (
        <div className="relative flex w-full overflow-hidden items-center justify-center bg-surface-soft">
            {/* Media frame (layout anchor) */}
            <div className="flex justify-between gap-4 items-center lg:block relative w-full lg:max-w-[70%] p-8 lg:p-0 min-h-[640px]">
                {/* Patient View */}
                <div className="lg:absolute left-0 -top-8 z-10 flex lg:block flex-col items-center w-full lg:w-fit">
                    <PhoneFrameVideo
                        videoSrc={MARKETING_MEDIA.patientViewScreen.src}
                        poster={assets.patient_part_thumbnail}
                        className="lg:w-[260px] w-full max-w-[200px] lg:max-w-full"
                    />
                    <p className="mt-3 text-base md:text-xl text-center font-semibold text-black">Patient View</p>
                </div>

                {/* Doctor View (overlapping & offset) */}
                <div className="lg:absolute right-0 -bottom-8 z-20 lg:block flex flex-col items-center w-full lg:w-fit">
                    <p className="mb-3 text-base md:text-xl text-center text-black font-semibold">Doctor View</p>
                    <PhoneFrameVideo
                        poster={assets.doctor_notification_thumbnail}
                        videoSrc={MARKETING_MEDIA.doctorNotificationScreen.src}
                        className="lg:w-[260px] w-full max-w-[200px] lg:max-w-full"
                    />
                </div>
            </div>
        </div>
    );
}
